(function () {
  const AFTERPAY_SELECTOR =
    'square-placement[data-mpid="beyond-clothing-usa.myshopify.com"][data-page-type="product"]';

  function getProductRoot(ocpButton) {
    const sectionId = ocpButton.dataset.sectionId;

    return (
      document.getElementById('MainProduct-' + sectionId) ||
      document.getElementById('ProductInfo-' + sectionId) ||
      ocpButton.closest('section') ||
      ocpButton.closest('.shopify-section') ||
      document
    );
  }

  function getSelectedColor(root) {
    const checkedColorInput =
      root.querySelector('input[type="radio"][name="Color"]:checked') ||
      root.querySelector('input[type="radio"][name="options[Color]"]:checked');

    if (checkedColorInput) {
      return checkedColorInput.value;
    }

    const colorSelect =
      root.querySelector('select[name="Color"]') ||
      root.querySelector('select[name="options[Color]"]');

    if (colorSelect) {
      return colorSelect.value;
    }

    return null;
  }

  function getAfterpayProductPlacements(root) {
    const scopedPlacements = root.querySelectorAll(AFTERPAY_SELECTOR);

    if (scopedPlacements.length) {
      return scopedPlacements;
    }

    return document.querySelectorAll(AFTERPAY_SELECTOR);
  }

  function updateAfterpayVisibility(root, isOcpActive) {
    const afterpayPlacements = getAfterpayProductPlacements(root);

    afterpayPlacements.forEach(function (placement) {
      if (isOcpActive) {
        placement.style.setProperty('display', 'none', 'important');
        placement.style.setProperty('visibility', 'hidden', 'important');
        placement.style.setProperty('height', '0', 'important');
        placement.style.setProperty('margin', '0', 'important');
        placement.style.setProperty('padding', '0', 'important');
        placement.style.setProperty('overflow', 'hidden', 'important');
      } else {
        placement.style.removeProperty('display');
        placement.style.removeProperty('visibility');
        placement.style.removeProperty('height');
        placement.style.removeProperty('margin');
        placement.style.removeProperty('padding');
        placement.style.removeProperty('overflow');
      }
    });
  }

  function getOcpProductForm(ocpButton, root) {
    const wrapper =
      ocpButton.closest('[data-ocp-buy-buttons-wrapper]') ||
      ocpButton.parentElement;

    if (wrapper) {
      const scopedForm = wrapper.querySelector('[data-ocp-product-form]');

      if (scopedForm) {
        return scopedForm;
      }
    }

    return root.querySelector('[data-ocp-product-form]');
  }

  function updateProductFormVisibility(ocpButton, root, isOcpActive) {
    const productForm = getOcpProductForm(ocpButton, root);

    if (!productForm) return;

    if (isOcpActive) {
      productForm.style.display = 'none';
    } else {
      productForm.style.removeProperty('display');
    }
  }

  function updateOcpGatingState(ocpButton) {
    const root = getProductRoot(ocpButton);
    const ocpColors = (ocpButton.dataset.ocpColor || '')
      .split(',')
      .map(function (color) {
        return color.trim();
      })
      .filter(Boolean);

    const selectedColor = getSelectedColor(root);
    const isOcpActive = ocpColors.includes(selectedColor);

    if (isOcpActive) {
      ocpButton.style.display = 'flex';
      ocpButton.style.marginBottom = '20px';
      document.documentElement.classList.add('ocp-afterpay-hidden');
      document.body.classList.add('ocp-afterpay-hidden');
    } else {
      ocpButton.style.display = 'none';
      document.documentElement.classList.remove('ocp-afterpay-hidden');
      document.body.classList.remove('ocp-afterpay-hidden');
    }

    updateProductFormVisibility(ocpButton, root, isOcpActive);
    updateAfterpayVisibility(root, isOcpActive);
  }

  function scheduleUpdate(ocpButton) {
    updateOcpGatingState(ocpButton);

    window.requestAnimationFrame(function () {
      updateOcpGatingState(ocpButton);
    });

    setTimeout(function () {
      updateOcpGatingState(ocpButton);
    }, 100);

    setTimeout(function () {
      updateOcpGatingState(ocpButton);
    }, 300);

    setTimeout(function () {
      updateOcpGatingState(ocpButton);
    }, 700);
  }

  function scheduleAllUpdates() {
    document.querySelectorAll('[data-ocp-gating-btn]').forEach(function (ocpButton) {
      scheduleUpdate(ocpButton);
    });
  }

  function initOcpGating() {
    const ocpButtons = document.querySelectorAll('[data-ocp-gating-btn]');

    if (!ocpButtons.length) return;

    scheduleAllUpdates();

    document.addEventListener('change', function (event) {
      if (
        event.target.matches('input[type="radio"]') ||
        event.target.matches('select') ||
        event.target.matches('input[name="id"]')
      ) {
        scheduleAllUpdates();
      }
    });

    document.addEventListener(
      'click',
      function (event) {
        const clickedAddToCart = event.target.closest('button[name="add"]');

        if (clickedAddToCart) {
          scheduleAllUpdates();
        }
      },
      true
    );

    document.addEventListener('variant:change', scheduleAllUpdates);
    document.addEventListener('variantChange', scheduleAllUpdates);
    document.addEventListener('cart:updated', scheduleAllUpdates);
    document.addEventListener('cart:refresh', scheduleAllUpdates);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOcpGating);
  } else {
    initOcpGating();
  }
})();